import { TimeSlot } from "../types/asset";

export const TIME_SLOTS: readonly TimeSlot[] = [
  "08:00",
  "10:00",
  "12:00",
  "14:00",
  "16:00",
  "18:00",
  "20:00",
  "22:00",
] as const;

export const UI_CONFIG = {
  ASSET_ICON_SIZES: {
    sm: "w-6 h-6 text-xs",
    md: "w-8 h-8 text-sm",
  },
  ANIMATION_DURATION: 200,
  MODAL_MAX_HEIGHT: "max-h-80",
  FORM_HEIGHT: "h-14",
} as const;

export const DEFAULT_FORM_VALUES = {
  stackName: "",
  stackType: "wallet" as const,
  stackAmount: "",
  assetToBuy: "",
  frequency: {
    type: "week" as const,
    dayOfWeek: "tuesday",
  },
  startDateTime: "",
};

export const VALIDATION_MESSAGES = {
  REQUIRED_STACK_NAME: "Enter a valid name for your AutoStack",
  STACK_NAME_MAX_LENGTH: "Stack name cannot exceed 50 characters",
  REQUIRED_AMOUNT: "Please enter a valid stacking amount",
  INVALID_AMOUNT_MIN: "Amount must be greater than 0",
  INSUFFICIENT_BALANCE: "You don't have enough balance",
  REQUIRED_ASSET: "Select an asset to buy",
  REQUIRED_FREQUENCY: "Select frequency",
  REQUIRED_TIME: "Select time for daily frequency",
  REQUIRED_START_DATE: "Select start date and time",
  NO_ASSETS_FOUND: "No assets found matching",
} as const;

export const ASSET_ICON_STYLES = {
  container: "bg-purple-900 rounded-full flex items-center justify-center",
  text: "text-white font-medium",
} as const;
